/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowDebtorCollectionForProductQueryResponse, GetShowDebtorCollectionForProductPathParams, GetShowDebtorCollectionForProductQueryParams, GetShowDebtorCollectionForProduct401, GetShowDebtorCollectionForProduct403 } from "../../models/GetShowDebtorCollectionForProduct";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowDebtorCollectionForProductUrl({ debtorCode, productCode }: { debtorCode: GetShowDebtorCollectionForProductPathParams["debtorCode"]; productCode: GetShowDebtorCollectionForProductPathParams["productCode"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/collections/${productCode}` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections/:productCode}
 */
export async function getShowDebtorCollectionForProduct({ debtorCode, productCode, params }: { debtorCode: GetShowDebtorCollectionForProductPathParams["debtorCode"]; productCode: GetShowDebtorCollectionForProductPathParams["productCode"]; params: GetShowDebtorCollectionForProductQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowDebtorCollectionForProductQueryResponse, ResponseErrorConfig<GetShowDebtorCollectionForProduct401 | GetShowDebtorCollectionForProduct403>, unknown>({ method : "GET", url : getGetShowDebtorCollectionForProductUrl({ debtorCode, productCode }).url.toString(), params, ... requestConfig })  
  return res.data
}